import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignEndVertical: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '16', height: '6', x: '2', y: '4', rx: '2' }],
    ['rect', { width: '9', height: '6', x: '9', y: '14', rx: '2' }],
    ['path', { d: 'M22 22V2' }],
  ],
];

export default AlignEndVertical;
